import { Navigate } from "react-router-dom";

import { LanguageCode } from "@/utils/i18n";

import { useSessionLanguageCode } from ".";

export const LanguageRedirect = ({
    nextUrlPattern,
}: {
    nextUrlPattern: (lang: LanguageCode) => string;
}) => {
    const [sessionLanguageCode] = useSessionLanguageCode();

    // const handleLanguageSelection = useCallback(
    //     (languageCode: LanguageCode) => {
    //         setSessionLanguageCode(languageCode);
    //         const path = nextUrlPattern(languageCode);
    //         navigate(path);
    //     },
    //     [setSessionLanguageCode, nextUrlPattern, navigate]
    // );

    if (sessionLanguageCode) {
        const path = nextUrlPattern(sessionLanguageCode);
        return <Navigate to={path} />;
    }

    const defaultLanguage = nextUrlPattern("en");

    return <Navigate to={defaultLanguage} />;
};
